import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import { ButtonBreadcrumb, LineVertical } from 'components/Button';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MANAGE_TRACKING_CODE_PATH, REGISTER_PATH } from 'constant/appPath';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import {
  deleteTrackingCode,
  getTrackingCode,
} from 'api/trackingCode/trackingCode.api';
import {
  defaultPageSizeOptions,
  defaultSelectPageSizeOption,
} from 'constant/Pagination/pageSizeOption';
import { IconWrapper } from 'page/Application/ManagerAccountPartner/AccountPartnerList/styled';
import HeaderListDataLayout from 'components/Layout/HeaderListDataLayout';
import LayoutDefault from 'components/Layout/LayoutDefault';
import { ButtonStyled } from 'page/Application/ManageCompanyList/CompanyList/styled';
import useModalConfirm from 'hook/useModalConfirm';
import SelectAllTable from 'page/Application/ManageAccountSoliton/AccountSolitonList/component/SelectAllTable';
import TableData from 'page/Application/ManageTrackingCode/component/TableData';
import { SORT_DIRECTION } from 'constant/sortConstants';
import Pagination from 'components/Pagination';
import useCustomMutate from 'hook/useQuery/useCustomMutate';
import useSetTitlePage from 'hook/useSetTitlePage';

const TrackingCodeList = () => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();
  const navigate = useNavigate();
  const [page, setPage] = useState(10);
  const [current, setCurrent] = useState(1);
  const [listIdSelected, setListIdSelected] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const { handleConfirmAction, contextHolder } = useModalConfirm();
  const [selectAllData, setSelectAllData] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [sortedInfo, setSortedInfo] = useState({});
  const { useMutationAPI } = useCustomMutate();

  const listItem = useMemo(() => {
    return [
      {
        title: <Link to={'/'}>企業管理</Link>,
      },
      {
        title: 'トラッキングコード',
      },
    ];
  }, []);

  const { data: trackingCodeList = [], isLoading } = useQueryAPI({
    api: getTrackingCode,
    key: 'getTrackingCodeList',
    params: {
      pageNumber: current,
      pageSize: page,
      isAll: selectAllData,
    },
  });

  const { mutate: deleteTrackingCodeMutate, isLoading: loadingDelete } =
    useMutationAPI({
      api: deleteTrackingCode,
      refetchKey: 'getTrackingCodeList',
      messageSuccess: `トラッキングコード${selectAllData ? trackingCodeList?.data?.total : listIdSelected?.length > 1 ? listIdSelected?.length : '1'}件を削除しました。`,
    });

  const handleNavigate = () => {
    if (isOnline) {
      navigate(`/${MANAGE_TRACKING_CODE_PATH}/${REGISTER_PATH}`);
    } else {
      errorNetWork();
    }
  };

  const handleChangePageSize = (value) => {
    if (isOnline) {
      setPage(value);
      setCurrent(1);
    } else {
      errorNetWork();
    }
  };

  const handleMultiDelete = () => {
    if (isOnline) {
      const payload = {
        listTrackingCodeId: listIdSelected,
        isAll: selectAllData,
      };
      deleteTrackingCodeMutate(payload);
      setListIdSelected([]);
      setSelectedRowKeys([]);
    } else {
      errorNetWork();
    }
  };

  const handleDeleteTrackingCode = (id) => {
    if (isOnline) {
      const payload = {
        listTrackingCodeId: [id],
        isAll: false,
      };
      deleteTrackingCodeMutate(payload);
      setListIdSelected([]);
    } else {
      errorNetWork();
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    if (isOnline) {
      setSortedInfo({
        sortField: sorter.order && sorter.field,
        sortDirection: sorter.order && SORT_DIRECTION[sorter.order],
        order: sorter.order,
        columnKey: sorter.columnKey,
      });
    } else {
      errorNetWork();
    }
  };

  const handleSelectAllRecord = () => {
    if (isOnline) {
      if (!selectAllData) {
        setSelectAllData((current) => !current);
      } else {
        handleSelectRowToDefault();
      }
    } else {
      errorNetWork();
    }
  };

  const handleSelectRowToDefault = () => {
    if (isOnline) {
      setSelectAllData(false);
      setSelectedRowKeys([]);
      setListIdSelected([]);
    } else {
      errorNetWork();
    }
  };

  const handlePagingChange = (pageNumber, pageSize) => {
    if (isOnline) {
      setCurrent(pageNumber);
      setPage(pageSize);
    } else {
      errorNetWork();
    }
  };

  useSetTitlePage(`トラッキングコード | Soliton パートナーサイト`, true);

  return (
    <>
      <Breadcrumb listItem={listItem} titlePage="トラッキングコード">
        <ButtonBreadcrumb
          text={'新規登録'}
          icon={<PlusOutlined />}
          onClick={handleNavigate}
        />
      </Breadcrumb>
      <LayoutDefault>
        {contextErrorNetWork}
        {contextHolder}
        <HeaderListDataLayout
          loading={isLoading}
          value={page}
          handleChangePageSize={handleChangePageSize}
          pageSizeOptions={defaultSelectPageSizeOption}
          titleScreen={'トラッキングコード一覧'}
          isHidden={true}
        >
          <ButtonStyled
            type="text"
            disabled={listIdSelected?.length === 0 || isDisable}
            size={'middle'}
            style={{
              lineHeight: 1.5714285714285714,
            }}
            icon={
              <IconWrapper
                style={{
                  opacity: listIdSelected?.length === 0 || isDisable ? 0.3 : 1,
                }}
              >
                <DeleteOutlined />
              </IconWrapper>
            }
            onClick={() => {
              if (isOnline) {
                handleConfirmAction({
                  confirmFn: handleMultiDelete,
                  title: (
                    <div>
                      <span>トラッキングコード</span>
                      <span style={{ fontSize: '16px' }}>
                        {selectAllData
                          ? trackingCodeList?.data?.total
                          : listIdSelected?.length}
                      </span>
                      <span>件を削除してもよろしいで しょうか？</span>
                    </div>
                  ),
                  okText: <span> 削除</span>,
                  setIsDisable: setIsDisable,
                });
                setIsDisable(true);
              } else {
                errorNetWork();
              }
            }}
          >
            削除
          </ButtonStyled>
          <LineVertical />
        </HeaderListDataLayout>
        {listIdSelected?.length !== 0 && (
          <SelectAllTable
            dataRaw={trackingCodeList?.data}
            handleSelectAllRecord={handleSelectAllRecord}
            selectAllData={selectAllData}
            listIdSelected={listIdSelected}
          />
        )}
        <TableData
          setCurrent={setCurrent}
          isLoading={isLoading || loadingDelete}
          isDisable={isDisable}
          setIsDisable={setIsDisable}
          dataRaw={trackingCodeList?.data}
          handleDeleteTrackingCode={handleDeleteTrackingCode}
          onChange={handleChange}
          setListIdSelected={setListIdSelected}
          listIdSelected={listIdSelected}
          selectAllData={selectAllData}
          setSelectAllData={setSelectAllData}
          sortedInfo={sortedInfo}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <Pagination
          totalTitle={'トラッキングコード総数'}
          currentPage={current}
          pageSize={page}
          handlePagingChange={handlePagingChange}
          total={trackingCodeList?.data?.total}
          pageSizeOptions={defaultPageSizeOptions}
          handleChangePageSize={handleChangePageSize}
        />
      </LayoutDefault>
    </>
  );
};

export default TrackingCodeList;
